/**
 * @return {{feature: string}}
 */
export const popinBackToSchool = () => ({
  feature: 'popin_rentree',
});
